<template>
  <input
    :id="id"
    type="time"
    :value="formattedValue"
    @change="handleChange"
    @keyup.enter="$emit('enter')"
    :class="$style.timeInput"
  />
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{
  duration: number; // Duration in milliseconds
  id?: string;
}>();

const emit = defineEmits<{
  (e: "update:duration", duration: number): void;
  (e: "enter"): void;
}>();

const formattedValue = computed(() => {
  if (!props.duration) return "00:00";
  const hours = Math.floor(props.duration / (1000 * 60 * 60));
  const minutes = Math.floor((props.duration % (1000 * 60 * 60)) / (1000 * 60));
  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
    2,
    "0"
  )}`;
});

function handleChange(event: Event) {
  const input = event.target as HTMLInputElement;
  const timeValue = input.value; // Format: "HH:MM"

  if (!timeValue) {
    emit("update:duration", 0);
    return;
  }

  const [hours, minutes] = timeValue.split(":").map(Number);
  const durationMs = (hours * 60 * 60 + minutes * 60) * 1000;
  emit("update:duration", durationMs);
}
</script>

<style module>
.timeInput {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  padding: 6px 8px;
  color: white;
  font-size: 16px;
  font-weight: 600;
  font-family: inherit;
  min-width: 100px;
}

.timeInput:focus {
  outline: none;
  border-color: var(--primary-color);
  background: rgba(255, 255, 255, 0.15);
}
</style>
